<template>
  <div class="message full-height">
    <ld-header>
      消息
    </ld-header>
    <van-cell>
      <van-grid
        column-num="5"
        :border="false"
      >
        <van-grid-item
          v-for="item in menuList"
          :key="item.url"
          :icon="item.img"
          :text="item.title"
        />
      </van-grid>
    </van-cell>
    <div class="qgehomewrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <van-cell
          label="描述信息"
          value="内容"
          title="客服消息"
        >
          <template #icon>
            <img :src="kf">
          </template>
        </van-cell>
      </mescroll-vue>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Grid, GridItem, Icon, NoticeBar ,Cell,Image as VanImage} from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'

import approval from 'Components/Dynamic/btlh/images/message/approval.png'
import advice from 'Components/Dynamic/btlh/images/message/advice.png'
import message from 'Components/Dynamic/btlh/images/message/message.png'
import pay from 'Components/Dynamic/btlh/images/message/pay.png'
import order from 'Components/Dynamic/btlh/images/message/order.png'
import kf from 'Components/Dynamic/btlh/images/message/kf.png'


export default {
  name: 'Message',
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Cell.name]: Cell,
    [VanImage.name]: VanImage,
    MescrollVue,
  },
  data () {
    return {
      down:{ use: false },
      kfShow: false,
      kf,
      menuList: [
        {
          link: '/tk/tkQuery',
          title: '订单通知',
          img: order
        },
        {
          link: '/ht/htQuery',
          title: '审批通知',
          img: approval
        },
        {
          link: '/car/carQuery',
          title: '系统通知',
          img: message
        },
        {
          link: '/tr/trQuery',
          title: '交易通知',
          img: pay
        },
        {
          link: '/tr/trQuery',
          title: '反馈通知',
          img: advice
        }
      ],
      orderList:[]
    }
  },
  computed: {
    ...mapGetters(['loginConfig', 'userInfo', 'loginNotices'])
  },
  created () {
    this.getLoginNotice(0)
    this.getOrderList()
  },
  mounted () {
  },
  methods:{
    ...mapActions(['getLoginNotice']),
  },
}
</script>

<style lang="less" scoped>
.qgehomewrapper{
    height: calc(100vh - 80px);
  overflow: hidden;
}
    .home-banner {
        background-image: url('~Components/Dynamic/btlh/images/bg.png');
    }
.qgehome {
  position: relative;
  padding: 30px 10px 10px;
	> .logo {
		position: absolute;
		top: 18px;
		left: 15px;
		img {
            width: 57px;
		}
	}
    .box{
        padding:0 5px;
    }
  .welcome {
    position: absolute;
    top: 100px;
    left: 15px;
  }

  .home-notice {
    position: absolute;
    top: 66px;
    left: 15px;
    width: calc(100% - 29px);
  }

  .server {
    position: absolute;
    top: 15px;
    right: 17px;
    color: @color-text-white;
    font-size: 24px;

    > p {
      margin-top: -5px;
    }
  }
}
</style>
